import { useEffect, useState } from 'react';
import { LeadDetails } from '../../components/LeadDetails';
import { Lead } from '../../types/lead';
import { Loader2 } from 'lucide-react';
import { Toaster } from 'components/ui/sonner';
import { useSearchParams } from 'react-router-dom';
import { CallAPIGetPromise } from 'Common/commaon';
import { getDecodeId } from 'slices/userProfile/thunk';
import { LeadHistory } from 'components/HistoryLeads';
import './lead-management.css';
import './available-leads.css';

const LeadsHistory =()=> {
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentView, setCurrentView] = useState<'lead-history' | 'lead-details'>('lead-history');
  const [selectedLeadId, setSelectedLeadId] = useState<string | null>(null);
  const [refresh, setIsRefresh] = useState(false);
  const [historicalLeads, setHistoricalLeads] = useState<Lead[]>([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);
  const handleViewDetails = (leadId: string) => {
    setSelectedLeadId(leadId);
    setCurrentView('lead-details');
    const next = new URLSearchParams(searchParams);
    next.set('leadId', String(leadId));
    setSearchParams(next, { replace: true });
  };
  useEffect(() => {
    let active = true;
    setLoading(true);
    setLoadError(false);
    CallAPIGetPromise(`/jobs/getHistoryJobs/${getDecodeId()}`).then(response => {
      const res = response as { data?: Lead[] };
      if (active) setHistoricalLeads(res.data || []);
    }).catch(() => {
      if (active) setLoadError(true);
    }).finally(() => {
      if (active) setLoading(false);
    });
    return () => { active = false; };
  }, [refresh]);
  const getSelectedLead = (): Lead | undefined => {
    if (!selectedLeadId) return undefined;
    
    const lead = historicalLeads.find(l => String(l.id) === String(selectedLeadId));
    return lead;
  };
  const selectedLead = getSelectedLead();
  const handleBack = () => {
    setSelectedLeadId(null);
    setCurrentView("lead-history")
    const next = new URLSearchParams(searchParams);
    next.delete('leadId');
    setSearchParams(next, { replace: true });

    
  };
  useEffect(() => {
    const leadId = searchParams.get('leadId');
    if (!leadId || loading) return;
    if (historicalLeads.some((lead) => String(lead.id) === leadId)) {
      setSelectedLeadId(leadId);
      setCurrentView('lead-details');
    }
  }, [searchParams, loading, historicalLeads]);
  return (
    <div className='page-content tailwind-prefix lead-management-page'>
   <div className="lead-management-shell">
      <Toaster position="top-right" />
{loading ? <div className="available-leads-state" role="status" aria-label="Loading lead history"><Loader2 size={24} aria-hidden="true" /><p>Loading lead history…</p></div> : loadError ? <div className="available-leads-state" role="alert"><p>We couldn’t load your lead history. Please try again.</p><button type="button" className="available-lead-button" onClick={() => setIsRefresh(value => !value)}>Try again</button></div> : <>
   {currentView === 'lead-history' &&
        <LeadHistory
          leads={historicalLeads}
          onViewDetails={handleViewDetails}
        />}
 
 {currentView === 'lead-details' && selectedLead && (
        <LeadDetails
          lead={selectedLead}
          onBack={handleBack}
        />
      )}
     
                     
                     </>}
     


 
    
    </div>

    </div>
 
  );
}

export default LeadsHistory
